import { debounce } from '@nova/utils'
class StickyATB extends HTMLElement {
  constructor() {
    super();

    this.productForm = document.getElementById(this.getAttribute('data-form-id'));
    this.button = this.querySelector('button');
    this.visible = false;

    this.debounceToggleVisibility = debounce(this.toggleVisibility, 100);

    this.debounceToggleVisibility = this.debounceToggleVisibility.bind(this);
    this.scrollToProductForm = this.scrollToProductForm.bind(this);
    this.reRenderContent = this.reRenderContent.bind(this);
  }

  initEvents() {
    this.button = this.querySelector('button');

    this.button.removeEventListener('click', this.scrollToProductForm);
    window.removeEventListener('scroll', this.debounceToggleVisibility);

    this.button.addEventListener('click', this.scrollToProductForm);
    window.addEventListener('scroll', this.debounceToggleVisibility);
  }

  connectedCallback() {
    if (!this.productForm || !this.button) return;

    this.initEvents()
    document.addEventListener('nova:product:render-sticky-atb', this.reRenderContent)

    this.toggleVisibility();
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.scrollToProductForm);
    window.removeEventListener('scroll', this.debounceToggleVisibility);
  }

  reRenderContent(event) {
    const content = event.detail.html
    this.innerHTML = content.innerHTML
    this.initEvents()
  }

  scrollToProductForm() {
    this.productForm.scrollIntoView({  behavior: 'smooth', block: 'center' });
  }

  toggleVisibility() {
    const rect = this.productForm.getBoundingClientRect();
    const outOfView = rect.bottom < 0 || rect.top > window.innerHeight;

    if (window.innerWidth < 768 && outOfView) {
      this.classList.add('is-visible');
      this.visible = true;
    } else {
      this.classList.remove('is-visible');
      this.visible = false;
    }
  }
}

if (!customElements.get('sticky-atb')) {
  customElements.define('sticky-atb', StickyATB);
}
